var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"nyx-toggle"},[_c('span',{staticClass:"label",class:{ checked: _vm.AppTheme === 'dark_theme' }},[_c('i',{class:[
          _vm.AppTheme === 'dark_theme'
            ? 'bi bi-moon-stars-fill'
            : 'bi bi-brightness-high-fill',
        ]})]),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.AppTheme === 'dark_theme'},on:{"change":_vm.toggleThemeCheckbox}}),_c('span',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }